import React from 'react';
import * as consts from '../../../const';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { generateIteratorKey as keygen } from '../../../utils/helpers';

//import splitComponentProps from './utils/splitComponentProps';

const propTypes = {
  ...Dropdown.propTypes,

  // Toggle props.
  tcStyle: PropTypes.object,
  tcShowAllSites: PropTypes.func,
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  title: PropTypes.node.isRequired,
  noCaret: PropTypes.bool,
  tcOpenInModal: PropTypes.func,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: PropTypes.node
};

function splitComponentProps(props, Component) {
  const componentPropTypes = Component.propTypes;

  const parentProps = {};
  const childProps = {};

  Object.entries(props).forEach(([propName, propValue]) => {
    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

class TcDropdownButton extends React.Component {
  render() {
    const { tcStyle, tcOpenInModal, bsSize, bsStyle, title, children, ...props } = this.props;
    const { headerStyle, bodyStyle, footerStyle } = tcStyle;

    const [dropdownProps, toggleProps] = splitComponentProps(props, Dropdown.ControlledComponent);

    let body, footer;
    body = children.slice(0, children.length);

    if (children.length == 0) {
      body = (
        <li id="tc-dropdown-no-data" {...keygen()} className="report-item">
          <span className="report-name">{consts.RAPORTS_NO_DATA}</span>
        </li>
      );
    }

    if (children.length > 5) {
      footer = (
        <li {...keygen()} id="tc-dropdown-footer" className={`${footerStyle}`}>
          <a onClick={tcOpenInModal} className="link">
            {consts.RAPORTS_FOOTER}
          </a>
        </li>
      );
    }

    return (
      <Dropdown {...dropdownProps} bsSize={bsSize} bsStyle={bsStyle}>
        <Dropdown.Toggle {...toggleProps} bsSize={bsSize} bsStyle={bsStyle}>
          {title}
        </Dropdown.Toggle>

        <Dropdown.Menu className="tc-dropdown">
          <ul id="tc-dropdown-body" className={`${bodyStyle}`}>
            {body}
          </ul>
          {footer}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

TcDropdownButton.propTypes = propTypes;

export default TcDropdownButton;
